import { HierarchyCard } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const StyledHierarchyCard = styled(HierarchyCard)`
  width: 448px;
  margin-top: 10%;
  margin-inline: auto;
`
